'use strict';

import 'document-register-element';
import resizeStore from '../resize/resize.store';
import {http} from '../utils';
import dispatcher from '../dispatcher';
import History from '../navigation/history.class';

class Catalog extends HTMLElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._isDesktop = false;
    this._isMobile = false;

    this.dataScrollTime = this.dataset.scrollTime;

    this.resize = (e) => this._onResize(e);
    this.prevent = (e) => e.preventDefault();
    this.onMobileSubmit = (e) => this._onMobileSubmit(e);
    this.filterChange = (e) => this._filterChange(e);
    this.filterize = (e) => this._filterize(e);
  }
  connectedCallback() {
    this.switchButtons = this.querySelectorAll('.catalog-view-switcher input');
    this.catalogWrapper = this.querySelector('.catalog-items');

    this.main = document.querySelector('main');
    this.filterWrapper = this.querySelector('.catalog-filter-wrapper');
    this.filterWrapperParent = this.filterWrapper.parentNode;

    this.formFilter = this.querySelector('.catalog-filter');
    this.pagination = this.querySelector('.catalog-pagination');
    this.sortSelect = this.querySelector('.catalog-sort');

    this.filterAction = this.formFilter.action;

    for (let i = 0; this.switchButtons.length > i; i++) {
      const input = this.switchButtons[i];
      const value = input.value;

      if (input.checked) this.lastViewType = value;

      input.addEventListener('change', () => {
        this.catalogWrapper.classList.remove(this.lastViewType);
        this.catalogWrapper.classList.add(value);
        this.lastViewType = value
      });
    }

    const openButton = this.querySelector('.openFilterButton');
    openButton.addEventListener('click', () => document.documentElement.classList.add('filterActive'));

    const closeButton = this.querySelector('.closeFilterButton');
    closeButton.addEventListener('click', () => document.documentElement.classList.remove('filterActive'));

    this.pagination.addEventListener('change', this.filterize);
    this.sortSelect.onUpdate = this.filterChange;
    // this.sortSelect.removeEventListener('change', this.filterChange);

    this._onResize(resizeStore.getData());
    resizeStore.eventEmitter.subscribe(this.resize);
  }
  disconnectedCallback() {
    document.documentElement.classList.remove('filterActive');
    resizeStore.eventEmitter.unsubscribe(this.resize);
  }

  _onResize(e) {
    if (e.width < 860) {
      if (this._isDesktop) {
        this.formFilter.removeEventListener('submit', this.prevent);
        this.formFilter.removeEventListener('change', this.filterChange);
        // this.pagination.removeEventListener('change', this.filterize);
        // this.sortSelect.removeEventListener('change', this.filterChange);
        this._isDesktop = false;
      }
      if (!this._isMobile) {
        this.formFilter.addEventListener('submit', this.onMobileSubmit);
        this.main.appendChild(this.filterWrapper);
        this.filterWrapper.classList.add('mobile');

        this._isMobile = true;
      }
    } else {
      if (this._isMobile) {
        this.formFilter.removeEventListener('submit', this.onMobileSubmit);
        this.filterWrapperParent.appendChild(this.filterWrapper);
        this.filterWrapper.classList.remove('mobile');

        this._isMobile = false;
      }
      if (!this._isDesktop) {
        this.formFilter.addEventListener('submit', this.prevent);
        this.formFilter.addEventListener('change', this.filterChange);
        // this.pagination.addEventListener('change', this.filterize);
        // this.sortSelect.addEventListener('change', this.filterChange);

        this._isDesktop = true;
      }
    }
  }

  _onMobileSubmit(e) {
    this.prevent(e);
    this._filterChange(e);
    document.documentElement.classList.remove('filterActive');
  }

  _filterChange(e) {
    this.pagination.setAttribute('disabled', 'true');

    this._filterize();
  }

  async _filterize() {
    this.classList.add('loading');

    dispatcher.dispatch({
      type: 'scroll-to',
      time: this.dataScrollTime,
      elem: this
    });

    try {
      const promise = http({
        action: this.filterAction,
        data: new FormData(this.formFilter)
      });

      await new Promise((resolve, reject) => setTimeout(resolve, 310));

      const response = await promise;

      this.pagination.innerHTML = response.response.pagination;
      this.catalogWrapper.innerHTML = response.response.content;
      this.classList.remove('loading');
      this.pagination.removeAttribute('disabled');

      History.push({
        state: {
          title: response.response.title,
          href: response.response.url
        },
        title: response.response.title,
        href: response.response.url
      });

    } catch (e) {
      console.log(e);
      this.classList.remove('loading');
      this.pagination.removeAttribute('disabled');
    }
  }
}

window.customElements.define('catalog-view', Catalog);